import React from 'react';
import { useNavigate } from 'react-router-dom';

const formatEventDate = (start, end) => {
  if (!start) return '';
  const s = start.toDate ? start.toDate() : new Date(start);
  if (!end) {
    return s.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }
  const e = end.toDate ? end.toDate() : new Date(end);
  const sameMonth = s.getMonth() === e.getMonth() && s.getFullYear() === e.getFullYear();
  if (sameMonth) {
    // "June 1 – 3, 2026"
    const month = s.toLocaleDateString('en-US', { month: 'long' });
    const year = s.getFullYear();
    return `${month} ${s.getDate()} – ${e.getDate()}, ${year}`;
  }
  const sameYear = s.getFullYear() === e.getFullYear();
  const startFmt = s.toLocaleDateString('en-US', { month: 'long', day: 'numeric', ...(!sameYear && { year: 'numeric' }) });
  const endFmt = e.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  return `${startFmt} – ${endFmt}`;
};

const EventCard = ({ event }) => {
  const navigate = useNavigate();

  return (
    <div className="stt-event-card stt-event-card--clickable" onClick={() => navigate(`/events/${event.id}`)}>
      <p className="stt-event-title">{event.title}</p>
      <p className="stt-event-date">{formatEventDate(event.date, event.end_date)}</p>
      {event.details && (
        <p className="stt-event-details stt-event-details--single">{event.details}</p>
      )}
    </div>
  );
};

export default EventCard;
